const CookieList = {
  unsavedValue: 'unsavedValue',
};
export default CookieList;
